<template>
  <div class="dialog-dev-setting-wrapper">
    <el-dialog title="机台设置" :visible="visible" @open="onDialogOpen" @close="onDialogClose">
      <el-form label-position="top" ref="devSettingForm" :rules="devSettingRules" :model="devSettingForm">

        <el-form-item label="设备类型" prop="type">
          <el-select v-model="devSettingForm.type" placeholder="请选择设备类型">
            <el-option label="扭蛋机" value="gpm"></el-option>
            <el-option label="自动贩卖机" value="vm"></el-option>
            <el-option label="口红机" value="lpk"></el-option>
            <el-option label="脉冲" value="mc"></el-option>
            <el-option label="福袋机" value="fdj"></el-option>
            <el-option label="格子机" value="gzj"></el-option>
            <el-option label="未知" value="undefine"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="通讯协议" prop="protocol">
          <el-radio v-model="devSettingForm.protocol" label="MQTT">MQTT</el-radio>
          <el-radio v-model="devSettingForm.protocol" label="SOCKET">Socket</el-radio>
        </el-form-item>

        <el-form-item label="通讯是否加密" prop="conn_encry">
          <el-radio v-model="devSettingForm.conn_encry" :label="1">加密</el-radio>
          <el-radio v-model="devSettingForm.conn_encry" :label="0">不加密</el-radio>
        </el-form-item>

        <el-form-item label="进入支付页面是否主动发送 alive" prop="first_alive">
          <el-radio v-model="devSettingForm.first_alive" :label="1">主动发送</el-radio>
          <el-radio v-model="devSettingForm.first_alive" :label="0">不主动发送</el-radio>
        </el-form-item>

        <el-form-item label="是否通知设备游戏结果" prop="game_notify">
          <el-radio v-model="devSettingForm.game_notify" :label="1">通知设备</el-radio>
          <el-radio v-model="devSettingForm.game_notify" :label="0">不通知设备</el-radio>
        </el-form-item>

        <el-form-item
          label="危险操作"
          v-if="hasRes('dev_unbind')" >
          <el-button
            size="medium"
            type="danger"
            @click="onUnbind(settingDev)">解绑</el-button>
        </el-form-item>

        <el-form-item style="display: flex; justify-content: center;">
          <el-button type="danger" @click="onDevSettingSubmit">确定</el-button>
          <el-button @click="onDevSettingCancel">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'DialogDevSetting',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    settingDev: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      devSettingForm: {
        type: '',
        protocol: 'MQTT',
        conn_encry: 1,
        first_alive: 1,
        game_notify: 1
      },
      devSettingRules: {
        type: [
          { required: true, message: '请选择设备类型', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters('opUser', [
      'hasRes'
    ])
  },
  methods: {
    ...mapActions('device', [
      'unbind',
      'updateDevice'
    ]),

    onDialogOpen () {
      this.devSettingForm.sn = this.settingDev.sn
      this.devSettingForm.type = this.settingDev.type
      if ('protocol' in this.settingDev && this.settingDev.protocol !== '') {
        this.devSettingForm.protocol = this.settingDev.protocol
      } else {
        this.devSettingForm.protocol = 'MQTT'
      }
      if ('conn_encry' in this.settingDev) {
        this.devSettingForm.conn_encry = this.settingDev.conn_encry
      } else {
        this.devSettingForm.conn_encry = 1
      }
      if (this.settingDev.dev_details.length > 0) {
        this.devSettingForm.first_alive = this.settingDev.dev_details[0].first_alive
        this.devSettingForm.game_notify = this.settingDev.dev_details[0].game_notify
      } else {
        this.devSettingForm.first_alive = 1
        this.devSettingForm.game_notify = 0
      }
    },
    onDialogClose () {
      this.$emit('update:visible', false)
    },
    // 机台设置
    onDevSettingSubmit () {
      this.$refs['devSettingForm'].validate(valid => {
        if (valid) {
          this.updateDevice(
            this.devSettingForm
          ).then(res => {
            this.$message({
              type: 'success',
              message: '设备更新成功'
            })

            this.$emit('update:visible', false)
            this.$emit('data-change')
          }).catch(err => {
            console.log(err)
            this.$message({
              type: 'error',
              message: '设备更新失败'
            })

            this.$emit('update:visible', false)
          })
        }
      })
    },
    onDevSettingCancel () {
      this.$refs['devSettingForm'].resetFields()

      this.$emit('update:visible', false)
    },
    onUnbind (dev) {
      this.$confirm('此操作将永久解除该设备的绑定，是否继续', '设备解绑', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.unbind({
          sn: dev.sn
        }).then(res => {
          this.$message({
            type: 'success',
            message: '解绑成功'
          })

          this.$emit('update:visible', false)
          this.$emit('data-change')
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/sass/base";
</style>



// WEBPACK FOOTER //
// src/components/dev/DialogDevSetting.vue